import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import NetworkCall from "network/networkCall";
import Request from "network/request";

export const userRoleSlice = createSlice({
  name: "userRoleSlice",
  initialState: {
    userDetails: {},
  },
  reducers: {
    saveUserDetails: (state, action) => {
      state.userDetails = { ...action.payload };
    },
  },
});
export const fetchUserDetails = () => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(Request.getUserDetails(), false);
      const newData = response?.data;
      dispatch(saveUserDetails(newData));

      // message.success("success");
    } catch (error) {
      // setFieldErrorsFromServer(error, form, values);
      console.log({ error });
    }
  };
};

export const updateUserPassword = (body) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(Request.UpdatePassword(body));
      dispatch(fetchUserDetails());

      message.success(response.message);
      return response;
    } catch (error) {
      console.log({ error });
      message.error(error?.message);
      return error;
      // message.error("error occured");
    }
  };
};
export const updateUserDetails = (body) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(Request.UpdateUserDetails(body));
      dispatch(fetchUserDetails());

      message.success(response.message);
    } catch (error) {
      // setFieldErrorsFromServer(error, form, values);
      console.log({ error });
      // message.error("error occured");
    }
  };
};

export const { saveUserDetails } = userRoleSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const userDetails = (state) => state.userRole.userDetails;

export default userRoleSlice.reducer;
